import React from "react";
import { Airplay, Eye, Feather, LogOut, Play, Target,UserCheck,DollarSign,Users } from "react-feather";
import { Link, useLocation, useNavigate } from "react-router-dom";
import '../Style/login.css'

const Sidebar = ({ showSideBar, setShowSideBar, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;
  const handleLogoutClick = () => {
    onLogout();
    navigate("/login");
  }

  return (
    <div className={`side-navbar ${showSideBar ? "open" : ""}`}>
      <div className="sidebar-header">
        <img src="/image/asa_white.png" style={{ width: "60px" }} alt="Logo" />
        <span onClick={() => setShowSideBar(false)} style={{ cursor: "pointer" }}>
          ✕
        </span>
      </div>

      <ul className="sidebar-menu">
        <li className={isActive("/") ? "active" : ""}>
          <Link to="/"><Airplay color="black"/>Home</Link>
        </li>
        <li className={isActive("/vendorAdvance") ? "active" : ""}>
          <Link to="/vendorAdvance"><Feather color="black"/>Vendor Advance</Link>
        </li>
        <li className={isActive("/vehicleAdvance") ? "active" : ""}>
          <Link to="/vehicleAdvance"><Target color="black"/>Vehicle Advance</Link>
        </li>
        <li className={isActive("/billView") ? "active" : ""}>
          <Link to="/billView"><Eye color="black"/>Bills</Link>
        </li>
        <li className={isActive("/billProcess") ? "active" : ""}>
          <Link to="/billProcess"><Play color="black"/> Process</Link>
        </li>
          <li className={isActive("/billProcess") ? "active" : ""}>
          <Link to="/contractor"><UserCheck color="black"/> Contractor</Link>
        </li>
          <li className={isActive("/billProcess") ? "active" : ""}>
          <Link to="/contractorPayment"><DollarSign color="black"/> Contractor Payment</Link>
        </li>
        <li className={isActive("/wagon") ? "active" : ""}>
          <Link to="/wagon"><Users color="black"/> 
          Wagon</Link>
        </li>

        {/* LOGOUT */}
        <li className="logout">
          <button onClick={handleLogoutClick} className="logout-btn" style={{border:'none',backgroundColor:"transparent"}}>
            <span className="menu-icon"> <LogOut color="black"/>Logout</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
